var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, Paper, CircularProgress, Button, TextField, } from "@mui/material";
import { useForm } from "react-hook-form";
import { useAuth, useAsync, useDocumentTitle, } from "@modules/core/hooks";
export var ProfilePage = function () {
    var _a, _b, _c;
    useDocumentTitle("Profile");
    var initialForm = {
        username: "",
        password_new: "",
        passwordRepeat: "",
    };
    var _d = useAuth(), user = _d.user, changePassword = _d.changePassword;
    var _e = useAsync({ data: "", stat: "success", error: null }, { throwOnError: true }), run = _e.run, error = _e.error, data = _e.data, isLoading = _e.isLoading, isSuccess = _e.isSuccess, isError = _e.isError;
    var _f = useForm({
        mode: "onChange",
        defaultValues: initialForm,
    }), register = _f.register, handleSubmit = _f.handleSubmit, _g = _f.formState, errors = _g.errors, isValid = _g.isValid, setError = _f.setError;
    var doSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var res, _a, _b, score, feedback, e_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (data.password_new !== data.passwordRepeat) {
                        setError("passwordRepeat", {
                            type: "custom",
                            message: "PASSWORDS MISMATCH",
                        });
                        return [2 /*return*/];
                    }
                    if (!(data && user)) return [3 /*break*/, 6];
                    return [4 /*yield*/, fetch(process.env.REACT_PASSWORD_POLICY + "/user/validate", {
                            method: 'POST',
                            headers: { 'Content-type': 'application/json' },
                            body: JSON.stringify({
                                username: user === null || user === void 0 ? void 0 : user.email,
                                password: data === null || data === void 0 ? void 0 : data.password_new,
                                lang: 'en',
                            }),
                        })];
                case 1:
                    res = _c.sent();
                    return [4 /*yield*/, res.json()];
                case 2:
                    _a = _c.sent(), _b = _a.score, score = _b === void 0 ? null : _b, feedback = _a.feedback;
                    if (score < 4) {
                        setError("passwordRepeat", {
                            type: "custom",
                            message: feedback.warning ? feedback.warning : Array.isArray(feedback.suggestions) && feedback.suggestions.length
                                ? feedback.suggestions.join(' ')
                                : 'Password too weak',
                        });
                        return [2 /*return*/];
                    }
                    _c.label = 3;
                case 3:
                    _c.trys.push([3, 5, , 6]);
                    return [4 /*yield*/, run(changePassword({
                            email: (user === null || user === void 0 ? void 0 : user.email) || "",
                            password: data.password,
                            password_new: data.password_new || "",
                            password_new_repeat: data.passwordRepeat || "",
                        }))];
                case 4:
                    _c.sent();
                    return [3 /*break*/, 6];
                case 5:
                    e_1 = _c.sent();
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    return (_jsx("div", __assign({ className: "signin" }, { children: _jsxs(Paper, { children: [isSuccess && data !== "" ? (_jsx(Alert, __assign({ severity: "success" }, { children: data }))) : (""), isError ? _jsx(Alert, __assign({ severity: "error" }, { children: error === null || error === void 0 ? void 0 : error.message })) : "", _jsxs("form", __assign({ className: "password-reset-form", onSubmit: handleSubmit(function (data) {
                        doSubmit(data);
                    }) }, { children: [_jsx(TextField, __assign({}, register("password", {
                            required: "This field is required.",
                            minLength: {
                                value: 8,
                                message: "Minimum 8 letters required..",
                            },
                        }), { required: true, fullWidth: true, placeholder: "CURRENT PASSWORD", variant: "standard", label: "CURRENT PASSWORD", helperText: (_a = errors.password) === null || _a === void 0 ? void 0 : _a.message })), _jsx(TextField, __assign({}, register("password_new", {
                            required: "This field is required.",
                            minLength: {
                                value: 8,
                                message: "Minimum 8 letters required..",
                            },
                        }), { required: true, fullWidth: true, placeholder: "NEW PASSWORD", variant: "standard", label: "NEW PASSWORD", helperText: (_b = errors.password) === null || _b === void 0 ? void 0 : _b.message })), _jsx(TextField, __assign({}, register("passwordRepeat", {
                            required: "This field is required.",
                            minLength: {
                                value: 8,
                                message: "Minimum 8 letters required..",
                            },
                        }), { required: true, fullWidth: true, placeholder: "PASSWORD REPEAT", variant: "standard", label: "PASSWORD REPEAT", helperText: (_c = errors.passwordRepeat) === null || _c === void 0 ? void 0 : _c.message })), _jsxs("div", __assign({ className: "text-right" }, { children: [isLoading && _jsx(CircularProgress, { size: 30 }), !isLoading && (_jsx(Button, __assign({ type: "submit", disabled: !isValid, variant: "contained", color: "primary" }, { children: "SEND" })))] }))] }))] }) })));
};
